<template>
  <div>
    {{ show ? `¥ ${value}` : defalutContent }}
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number]
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defalutContent: "..."
    };
  }
};
</script>
